/*
 * LXD below-the-fold behaviour (sections/lxd-details, lxd-polarisation,
 * lxd-compare). Plain script, loaded with defer by each section; guarded so
 * a page that loads it several times only wires each element once. Re-runs
 * on shopify:section:load so the theme editor stays live.
 *
 * Details carousel: at 2-up the last card can never scroll to the left edge,
 * so the active card is tracked separately from the scroll position. At the
 * end of the track a swipe marks the last card, while a pin / dot / arrow
 * that asked for a card keeps that card marked. Dots are buttons.
 */
(function () {
  if (window.__lxdBelow) { window.__lxdBelow.init(document); return; }

  var COND = { flats: 'Flats', estuary: 'Estuary', reef: 'Reef', offshore: 'Offshore', 'low-light': 'Low light', overcast: 'Overcast' };
  var BASE = { smoke: '#3E4348', brown: '#4E3120', green: '#2E4A3A', rose: '#6E4048' };
  var MIRRORS = { blue: 1, green: 1, gold: 1, silver: 1 };
  var FRAME = '<path d="M22.5 1.5H9.5L1.5 9.5V22.5M25.5 1.5H38.5L46.5 9.5V22.5M46.5 25.5V38.5L38.5 46.5H25.5M22.5 46.5H9.5L1.5 38.5V25.5" stroke="#151C26" stroke-width="3" fill="none"/>';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function cap(s) { s = String(s || ''); return s.charAt(0).toUpperCase() + s.slice(1); }

  /* ---------- details: tabs, pins, carousel ---------- */
  function initDetails(root) {
    if (root.__lb) return; root.__lb = 1;
    var stage = root.querySelector('[data-lb-stage]');
    var car = root.querySelector('[data-lb-car]');
    if (!car) return;
    var cards = [].slice.call(car.children);
    var dots = [].slice.call(root.querySelectorAll('[data-lb-dots] .lb-dot'));
    var prev = root.querySelector('[data-lb-prev]');
    var next = root.querySelector('[data-lb-next]');
    var cur = 0, target = null, settle = null, expect = 0;

    function maxScroll() { return car.scrollWidth - car.clientWidth; }
    function fromPosition() {
      var step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : car.clientWidth;
      var i = Math.round(car.scrollLeft / Math.max(1, step));
      if (car.scrollLeft >= maxScroll() - 4) i = cards.length - 1; // end of track: last card
      i = Math.max(0, Math.min(cards.length - 1, i));
      if (i !== cur) mark(i);
    }
    function release() {
      // a requested card stays marked only while the track sits where the request put it
      var moved = target !== null && Math.abs(car.scrollLeft - expect) > 4;
      target = null;
      if (moved) fromPosition();
    }
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
      car.addEventListener(ev, function () { target = null; }, { passive: true });
    });
    function mark(i) {
      cur = i;
      dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      if (stage) stage.querySelectorAll('.lb-pin').forEach(function (p) { p.classList.toggle('is-act', +p.dataset.card === i); });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= cards.length - 1;
    }
    function go(i) {
      if (!cards.length) return;
      i = Math.max(0, Math.min(cards.length - 1, i));
      target = i;
      var left = Math.min(cards[i].offsetLeft - cards[0].offsetLeft, maxScroll());
      expect = left;
      car.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
      mark(i);
      clearTimeout(settle); settle = setTimeout(release, 900);
    }
    car.addEventListener('scroll', function () {
      if (!cards.length) return;
      if (target !== null) { // a requested scroll: keep what was asked for until it settles
        clearTimeout(settle); settle = setTimeout(release, 160);
        return;
      }
      fromPosition();
    }, { passive: true });
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); }); });

    if (stage) {
      stage.querySelectorAll('.lb-pin').forEach(function (p) { p.addEventListener('click', function () { go(+p.dataset.card); }); });
      var tabs = [].slice.call(root.querySelectorAll('.lb-tab'));
      function show(view) {
        tabs.forEach(function (t) { t.setAttribute('aria-selected', t.dataset.view === view ? 'true' : 'false'); });
        stage.querySelectorAll('.lb-stage__img').forEach(function (im) { im.classList.toggle('is-on', im.classList.contains('lb-stage__img--' + view)); });
        stage.querySelectorAll('.lb-pins').forEach(function (pp) { pp.classList.toggle('is-on', pp.dataset.view === view); });
        mark(cur);
      }
      tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.view); }); });
      if (tabs.length) show(tabs[0].dataset.view);
    }
    mark(0);
  }

  /* ---------- polarisation slider ---------- */
  function initSlider(ba) {
    if (ba.__lb) return; ba.__lb = 1;
    var r = ba.querySelector('input[type=range]');
    if (!r) return;
    function set() { ba.style.setProperty('--x', r.value + '%'); }
    r.addEventListener('input', set);
    set();
  }

  /* ---------- which-lens carousel (one swipeable row at every width) ------
   * One dot per reachable snap position: when several cards show at once the
   * last cards share the end position, so the extra dots are hidden and every
   * visible dot can light. Prev / next arrows (desktop) step one position and
   * disable at the ends. A mouse can drag the row (touch and trackpads scroll
   * natively); snap is paused while dragging, then the row settles on the
   * nearest position. Recomputed on resize. */
  function initLens(root) {
    if (root.__lb) return; root.__lb = 1;
    var car = root.querySelector('[data-lb-lens-car]');
    var dots = [].slice.call(root.querySelectorAll('[data-lb-lens-dots] .lb-dot'));
    var prev = root.querySelector('[data-lb-lens-prev]'), next = root.querySelector('[data-lb-lens-next]');
    if (!car) return;
    var cards = [].slice.call(car.children), cur = -1, pos = [0];
    function positions() {
      var max = Math.max(0, car.scrollWidth - car.clientWidth), out = [];
      cards.forEach(function (c) {
        var x = Math.min(c.offsetLeft - cards[0].offsetLeft, max);
        if (!out.length || x - out[out.length - 1] > 4) out.push(x);
      });
      if (max > 0 && max - out[out.length - 1] > 4) out.push(max);
      pos = out.length ? out : [0];
      dots.forEach(function (d, j) { d.hidden = j >= pos.length; });
      cur = -1;
    }
    function mark(i) {
      if (i === cur) return; cur = i;
      dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= pos.length - 1;
    }
    function nearest() {
      var x = car.scrollLeft, best = 0;
      if (x + car.clientWidth >= car.scrollWidth - 2) return pos.length - 1;
      pos.forEach(function (p, j) { if (Math.abs(p - x) < Math.abs(pos[best] - x)) best = j; });
      return best;
    }
    function fromPosition() { mark(nearest()); }
    function go(i) {
      i = Math.max(0, Math.min(pos.length - 1, i));
      car.scrollTo({ left: pos[i], behavior: reduce ? 'auto' : 'smooth' });
    }
    car.addEventListener('scroll', fromPosition, { passive: true });
    window.addEventListener('resize', function () { positions(); fromPosition(); }, { passive: true });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); }); });
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });

    // mouse drag (pointer type mouse only)
    var drag = null;
    car.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || car.scrollWidth <= car.clientWidth) return;
      drag = { x: e.clientX, left: car.scrollLeft, moved: false, id: e.pointerId };
    });
    car.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) > 4) { drag.moved = true; car.classList.add('is-dragging'); try { car.setPointerCapture(drag.id); } catch (err) {} }
      if (drag.moved) car.scrollLeft = drag.left - dx;
    });
    function endDrag(e) {
      if (!drag || (e && e.pointerId !== drag.id)) return;
      var moved = drag.moved; drag = null;
      if (!moved) return;
      car.classList.remove('is-dragging');
      go(nearest());
      car.addEventListener('click', function stop(ev) { ev.preventDefault(); ev.stopPropagation(); }, { capture: true, once: true });
    }
    car.addEventListener('pointerup', endDrag);
    car.addEventListener('pointercancel', endDrag);
    car.addEventListener('dragstart', function (e) { e.preventDefault(); });

    positions(); fromPosition();
  }

  /* ---------- compare ---------- */
  function chip(uid, base, mirror) {
    var c = BASE[base] || BASE.smoke;
    var left = MIRRORS[mirror] ? 'url(#lb-m-' + mirror + '-' + uid + ')' : c;
    return '<svg class="lb-chip" viewBox="0 0 48 48" aria-hidden="true" focusable="false">' + FRAME +
      '<g clip-path="url(#lb-oct-' + uid + ')"><rect x="0" y="0" width="24" height="48" fill="' + left + '"/><rect x="24" y="0" width="24" height="48" fill="' + c + '"/></g>' +
      '<path d="M24 6V42" stroke="#fff" stroke-width="2"/></svg>';
  }
  function lensName(b, m, p) {
    if (!MIRRORS[m]) return cap(b) + (p ? ' photochromic' : ', no mirror');
    return cap(m) + ' over ' + b + (p ? ', photochromic' : '');
  }
  function initCompare(root) {
    if (root.__lb) return; root.__lb = 1;
    var dataEl = root.querySelector('[data-lb-cmp-data]');
    var sel = root.querySelector('[data-lb-cmp-sel]');
    var rowsEl = root.querySelector('[data-lb-cmp-rows]');
    var img = root.querySelector('[data-lb-cmp-img]');
    if (!dataEl || !sel || !rowsEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var uid = root.dataset.uid || '';
    var L = data.labels || {};
    var icons = {};
    root.querySelectorAll('template[data-lb-ico]').forEach(function (t) { icons[t.dataset.lbIco] = t.innerHTML; });
    function ico(k) { return icons[k] ? '<i class="lb-ico">' + icons[k] + '</i>' : ''; }
    var others = (data.others || []).filter(function (f) { return f && f.h; });
    // glass first, then polycarbonate, keeping collection order inside each
    others.sort(function (a, b) { return (a.mat === 'polycarbonate') - (b.mat === 'polycarbonate'); });
    var byH = {};
    others.forEach(function (f) {
      byH[f.h] = f;
      var o = document.createElement('option');
      o.value = f.h;
      o.textContent = f.name + (f.mat === 'polycarbonate' ? ' (poly)' : '');
      sel.appendChild(o);
    });
    function big(text, muted) { return '<span class="lb-cv__big' + (muted ? ' lb-cv__muted' : '') + '">' + esc(text) + '</span>'; }
    var ROWS = [
      [L.material, function (f) { return f.mat ? ico(f.mat) + big(cap(f.mat)) : big('Not stated', true); }, function (f) { return f.mat; }],
      [L.lenses, function (f) {
        return '<div class="lb-cv__lenses">' + f.lenses.map(function (l) { return '<span class="lb-cv__lens">' + chip(uid, l[0], l[1]) + esc(lensName(l[0], l[1], l[2])) + '</span>'; }).join('') + '</div>';
      }, function (f) { return JSON.stringify(f.lenses); }],
      [L.conds, function (f) {
        return '<div class="lb-cv__row">' + f.conds.map(function (c) { return '<span class="lb-cv__cond">' + ico(c) + esc(COND[c] || c) + '</span>'; }).join('') + '</div>';
      }, function (f) { return f.conds.join(); }],
      [L.cat, function (f) { return big('Cat 3') + (f.photo ? '<small>Photochromic Cat 2–3</small>' : ''); }, function (f) { return f.photo ? 'p' : ''; }],
      [L.shields, function (f) { return big(f.shields, f.shields === 'No'); }, function (f) { return f.shields; }],
      [L.photo, function (f) { return big(f.photo ? 'Yes' : 'No', !f.photo); }, function (f) { return f.photo; }],
      [L.sig, function (f) { var none = !f.sig || f.sig === 'None'; return big(none ? 'None' : f.sig, none) + (!none && L.sigNote ? '<small>' + esc(L.sigNote) + '</small>' : ''); }, function (f) { return f.sig; }]
    ];
    function draw() {
      var a = data.current, b = byH[sel.value];
      if (!b) return;
      if (img) {
        if (b.img) { img.src = b.img; img.removeAttribute('hidden'); } else { img.setAttribute('hidden', ''); }
        img.alt = b.name;
      }
      rowsEl.innerHTML = ROWS.map(function (r) {
        var diff = r[2](a) !== r[2](b);
        return '<div class="lb-crow' + (diff ? ' is-diff' : '') + '"><div class="lb-crow__rl">' + esc(r[0] || '') + '</div><div class="lb-crow__vals"><div class="lb-cv">' + r[1](a) + '</div><div class="lb-cv">' + r[1](b) + '</div></div></div>';
      }).join('');
    }
    sel.addEventListener('change', draw);
    draw();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-lb-details]').forEach(initDetails);
    (scope || document).querySelectorAll('[data-lb-ba]').forEach(initSlider);
    (scope || document).querySelectorAll('[data-lb-compare]').forEach(initCompare);
    (scope || document).querySelectorAll('[data-lb-lens]').forEach(initLens);
  }
  window.__lxdBelow = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
